// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-bg[data-v-2a06692d]{background:url(https://statics.get-base.com/b2b/whitepaper-bg.jpg);background-size:cover;background-position:top}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
